import React from 'react';

import { formatMoney } from '../../util/currency';
import { LINE_ITEM_DAMAGE_WAIVER, LINE_ITEM_LEGACY_DAMAGE_WAIVER } from '../../util/types';

import css from './OrderBreakdown.module.css';

const DAMAGE_WAIVER_CODES = [LINE_ITEM_DAMAGE_WAIVER, LINE_ITEM_LEGACY_DAMAGE_WAIVER];

const decimalToNumber = value => {
  if (typeof value?.toNumber === 'function') {
    return value.toNumber();
  }
  return Number(value);
};

const LineItemDamageWaiverMaybe = props => {
  const { lineItems, intl, snapshot } = props;
  const item = lineItems.find(
    lineItem => DAMAGE_WAIVER_CODES.includes(lineItem.code) && !lineItem.reversal
  );

  if (!item) {
    return null;
  }

  const isLegacy = item.code === LINE_ITEM_LEGACY_DAMAGE_WAIVER;
  const label =
    item.displayLabel ||
    snapshot?.displayLabel ||
    (isLegacy ? 'Damage Waiver & Admin Fee' : 'Damage Waiver');
  const description = item.description || snapshot?.description || undefined;
  const quantity = decimalToNumber(item.quantity);
  const quantityLabel = Number.isFinite(quantity) && quantity > 1 ? ` x ${quantity}` : '';

  return (
    <div className={css.lineItem} title={description}>
      <span className={css.itemLabel}>
        {label}
        {quantityLabel}
      </span>
      <span className={css.itemValue}>{formatMoney(intl, item.lineTotal)}</span>
    </div>
  );
};

export default LineItemDamageWaiverMaybe;
